const REGION_NAMES = new Intl.DisplayNames(["en"], { type: "region" });

export const countryName = (code?: string | null): string => {
  if (!code) return "Unknown";
  try {
    return REGION_NAMES.of(code) || code;
  } catch {
    return code;
  }
};

export const flagEmoji = (code?: string | null): string => {
  if (!code || code.length !== 2) return "🌍";

  const codePoints = code
    .toUpperCase()
    .split("")
    .map((char) => 127397 + char.charCodeAt(0));

  return String.fromCodePoint(...codePoints);
};
